<template>
  <div class="ban">
    <div style=" text-align: left;
    margin-bottom: 10px;">
      <el-button
        style="background:#8989ba;color:#fff;outline: none"
        @click="Batchoperation"
      >Create preference</el-button>
    </div>

    <el-table ref="multipleTable" :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="NO" width="50"></el-table-column>
      <el-table-column prop="efr_name" label="Preference name"></el-table-column>
      <el-table-column prop="efr_class" label="Priority" show-overflow-tooltip></el-table-column>
      <el-table-column prop="efc_value_cnname" label="Shipping method"></el-table-column>
      <el-table-column prop="efr_status" label="Status">
        <template slot-scope="scope" v-if="scope.row.efr_class!=401">
          <el-switch
            active-value="1"
            inactive-value="2"
            v-model="scope.row.efr_status"
            @change="changeSwitch(scope,scope.$index)"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="Operation" width="300" fixed="right">
        <template slot-scope="scope">
          <a @click="perfect(scope)" style="margin-left: 10px;">
            <i class="el-icon-edit" style="color:#56de97;font-size:22px;border:1px solid #56de97;"></i>
          </a>
          <a @click="remove(scope)" style="margin-left: 10px;" v-if="scope.row.efr_class!=401">
            <i class="el-icon-delete" style="color:#ff646a;font-size:22px;"></i>
          </a>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 1000]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <Edit-ing :visible="editVisible" ref="mychild" :companyList="companyList" @clearEdit="clearEdit"></Edit-ing>
    <Default-set :visible="defaVisible" :comdataList="comdataList" @cleardefa="cleardefa"></Default-set>
  </div>
</template>

<script>
import {
  getrulelist,
  changerulestatus,
  getrulecolsmap,
  getcolvals,
  editcolsmap
} from "../api/setting";
import editset from "./editsetting";
import defaultset from "./defaultset";
export default {
  components: {
    "Edit-ing": editset,
    "Default-set": defaultset
  },
  data() {
    return {
      loading:true,
      Pendingnum: 0,
      Invalidnum: 0,
      activeName: "",
      editVisible: false,
      defaVisible: false,
      total: 0,
      Pendingnum: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      comdataList: { ruleForm: {} },
      companyList: { ruleForm: {} },
      datanunm: {
        li: [],
        ruleForm: {
          accounts: [],
          countrys: [],
          Country: [],
          Account: [],
          alldata: "",
          skueparated: "",
          Wminvalue: "",
          Wmaxvalue: "",
          lte: "",
          gte: "",
          Customs: [],
          Prioritys: [],
          resource: "",
          custom: "",
          priority: "",
          entername: ""
        }
      }
    };
  },

  mounted() {
      let param = {
        page: 1,
        pageSize: 10
      };
      this.getlist(param);
  },

  methods: {
    Batchoperation() {
      this.$router.push({
        name: "Settingyi",
        params: {
          new: true
        }
      });
      //this.$router.push({ path: "/Settingyi" });
    },
    perfect(scope) {
      console.log(scope);
      if (scope.row.efr_class != 401) {
        let param = {
          id: scope.row.efc_id,
          warehouse_id: 18,
          sp_code: "CFF"
        };
        getcolvals(param)
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              this.datanunm.li = [];
              console.log(response.data.cond.length);
              for (let i = 0; i < response.data.cond.length; i++) {
                if (
                  response.data.cond[i].efc_sub_id == "3" || response.data.cond[i].efc_sub_id == "2" 
                ) {
                  console.log(response.data.cond[i].efc_sub_id);
                  console.log(scope.row.efr_id);
                  let cid = response.data.cond[i].efc_sub_id;
                  let param = {
                    rid: scope.row.efr_id,
                    cid: response.data.cond[i].efc_sub_id,
                    type: 1
                  };
                  editcolsmap(param)
                    .then(response => {
                      console.log(response);
                      if (response.data.ask == 1) {
                        if (cid == "3") {
                          let Customs = [];
                          for (
                            let i = 0;
                            i < Object.keys(response.data.data).length;
                            i++
                          ) {
                            let arr =
                              response.data.data[
                                Object.keys(response.data.data)[i]
                              ].data;
                            arr.forEach(function(value, index) {
                              console.log(value.id);
                              Customs.push(value.id);
                            });
                          }
                          this.datanunm.ruleForm.countrys = Customs;
                          let efcId = {
                            efcId: cid,
                            disabled: true
                          };
                          this.datanunm.li.push(efcId);
                        } else {
                          let Customs = [];
                          for (
                            let i = 0;
                            i < Object.keys(response.data.data).length;
                            i++
                          ) {
                            let arr =
                              response.data.data[
                                Object.keys(response.data.data)[i]
                              ].data;
                            arr.forEach(function(value, index) {
                              Customs.push(value.id);
                            });
                          }
                          this.datanunm.ruleForm.accounts = Customs;
                          let efcId = {
                            efcId: cid,
                            disabled: true
                          };
                          this.datanunm.li.push(efcId);
                        }
                      } else {
                        if (cid == "3") {
                          this.datanunm.ruleForm.countrys = [];
                        } else {
                          this.datanunm.ruleForm.accounts = [];
                        }
                      }
                    })
                    .catch(error => {
                      console.log(error);
                    });
                } else if (response.data.cond[i].efc_sub_id != "8") {
                  let cid = response.data.cond[i].efc_sub_id;
                  let param = {
                    rid: scope.row.efr_id,
                    cid: response.data.cond[i].efc_sub_id,
                    type: 1
                  };
                  getrulecolsmap(param)
                    .then(response => {
                      console.log(cid);
                      console.log(response);
                      if (response.data.ask == 1) {
                        if (cid == 1) {
                          this.datanunm.ruleForm.skueparated =
                            response.data.data[0].efc_column_value;
                          let efcId = {
                            efcId: cid,
                            disabled: true
                          };
                          this.datanunm.li.push(efcId);
                        } else if (cid == 10) {
                          this.datanunm.ruleForm.lte =
                            response.data.data[0].efc_column_value;
                         
                        } else if (cid == 11) {
                          this.datanunm.ruleForm.gte =
                            response.data.data[0].efc_column_value;
                             let efcId = {
                            efcId: "10",
                            disabled: true
                          };
                          this.datanunm.li.push(efcId);
                        } else if (cid == 12) {
                          this.datanunm.ruleForm.Wminvalue =
                            response.data.data[0].efc_column_value;
                          
                        } else if (cid == 13) {
                          this.datanunm.ruleForm. Wmaxvalue=
                            response.data.data[0].efc_column_value;
                            let efcId = {
                            efcId: "12",
                            disabled: true
                          };
                          this.datanunm.li.push(efcId);
                        }
                      } else { 
                        
                        if (cid == 10) {
                          this.datanunm.ruleForm.lte = "0";
                         
                        } else if (cid == 11) {
                          this.datanunm.ruleForm.gte ="0";
                           
                        } else if (cid == 12) {
                          this.datanunm.ruleForm.Wminvalue="0";
                          
                        } else if (cid == 13) {
                          this.datanunm.ruleForm.Wmaxvalue ="0";
                            



                      }}
                    })
                    .catch(error => {
                      console.log(error);
                    });
                }
              }
              this.datanunm.ruleForm.entername = scope.row.efr_name;
              this.datanunm.ruleForm.resource = Number(scope.row.efc_id);
              this.datanunm.ruleForm.priority = scope.row.efr_class;
              this.datanunm.ruleForm.custom = scope.row.efc_column_value;
              this.datanunm.rid = scope.row.efr_id;
              this.companyList = this.datanunm;
              let param = {
          id: 3,
          colType: 2,
          warehouse_id: 18,
           efcValue: scope.row.efc_column_value
        };
         this.$refs.mychild.getdatra(param)
              console.log(this.companyList)
              this.editVisible = true;
            } 
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.comdataList.ruleForm = scope.row;
        let param = {
          rid: scope.row.efr_id,
          cid: 11,
          type: 1
        };
        getrulecolsmap(param).then(response => {
          this.defaVisible = true;
          console.log(response);
          if (response.data.ask == 1) {
            this.comdataList.ruleForm.efr_last_update =
              response.data.data[0].efc_column_value;
            this.comdataList.ruleForm.efr_create_date = 2;
          } else {
            this.comdataList.ruleForm.efr_create_date = 1;
          }
        });

        this.comdataList.ruleForm.efc_id = Number(scope.row.efc_id);
        console.log(this.comdataList);
      }

      // this.editVisible=true
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      let param = {
        page: 1,
        pageSize: val
      };
      this.getlist(param);
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      let param = {
        page: val,
        pageSize: this.pageSize
      };
      this.getlist(param);
    },
    changeSwitch(scope, index) {
      console.log(scope);
      let tip = "forbidden";
      if (scope.row.efr_status == 2) {
        tip = "Enable";
      }
      this.$confirm("Is it " + tip + "?", "Tips", {
        confirmButtonText: "Determine",
        cancelButtonText: "cancel",
        type: "warning"
      })
        .then(() => {
          let param = {
            id: scope.row.efr_id,
            status: scope.row.efr_status,
            rclass: scope.row.efr_class
          };
          changerulestatus(param)
            .then(response => {
              console.log(response);
              if (response.data.ask == 1) {
                this.$message({
                  type: "success",
                  message: response.data.msg
                });
              } else {
                let newdata = scope.row.efr_status;
                newdata = newdata == 1 ? "2" : "1";
                this.tableData[index].efr_status = newdata;
               
              }
            })
            .catch(error => {
              console.log(error);
            });

        })
        .catch(() => {
          let newdata = scope.row.efr_status;
          newdata = newdata == 1 ? "2" : "1";
          this.tableData[index].efr_status = newdata;
        });
    },
    getlist(param) {
      this.loading=true;
      getrulelist(param)
        .then(response => {
          console.log(response);
           this.loading=false;
          if (response.data.ask == 1) {
            if (response.data.data.length > 0) {
              this.tableData = response.data.data;
              this.total = Number(response.data.total);
            } else {
              this.$router.push({
                name: "Settingyi",
                params: {
                  new: false
                }
              });
            }
          } 
        })
        .catch(error => {
          this.loading=false;
          console.log(error);
        });
    },
    clearEdit() {
      this.editVisible = false;
    },
    cleardefa() {
      this.defaVisible = false;
    },
    remove(scope) {
      this.$confirm("Whether to delete rules?", "Tips", {
        confirmButtonText: "Determine",
        cancelButtonText: "cancel",
        type: "warning"
      }).then(() => {
        let param = {
          id: scope.row.efr_id,
          status: 0,
          rclass: scope.row.efr_class
        };
        changerulestatus(param)
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              this.$message({
                type: "success",
                message: response.data.msg
              });
              this.handleCurrentChange(1)
            } 
          })
          .catch(error => {
            console.log(error);
          });
      });
    }
  }
};
</script>
<style>
.ban {
  background: #fff;
  margin: 20px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Setting/Setting.vue